import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { ChainTypeTab } from 'modules/common/components/ChainTypeTab';
import { JWT } from 'domains/jwtToken/types';
import { SecondaryTabs } from 'modules/common/components/SecondaryTabs';
import { setSelectedTokenIndex } from 'domains/jwtToken/store/jwtTokenManagerSlice';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useTabs } from 'modules/common/hooks/useTabs';

import { useCopyEndpointModalStyles } from '../../useCopyEndpointModalStyles';

interface ITokenSelectorProps {
  jwtTokens: JWT[];
  currentProjectIndex: number;
}

export const TokenSelector = ({
  currentProjectIndex,
  jwtTokens,
}: ITokenSelectorProps) => {
  const dispatch = useDispatch();

  const { accountAddress = '' } = useAccount();

  const handleSelectTokenIndex = useCallback(
    (newIndex: number) => {
      dispatch(
        setSelectedTokenIndex({
          tokenIndex: newIndex,
          address: accountAddress,
        }),
      );
    },
    [accountAddress, dispatch],
  );

  const { classes } = useCopyEndpointModalStyles();

  const tokenTabsData = useMemo(() => {
    return jwtTokens.map(token => ({
      id: token.index,
      title: (isSelected: boolean) => (
        <ChainTypeTab
          content={
            <div className={classes.projectTabContent}>{token.name}</div>
          }
          isSelected={isSelected}
        />
      ),
      onClick: () => handleSelectTokenIndex(token.index),
      onSelect: () => handleSelectTokenIndex(token.index),
    }));
  }, [classes.projectTabContent, handleSelectTokenIndex, jwtTokens]);

  const [tokenTabs, selectedTokenTab] = useTabs<JWT>({
    tabs: tokenTabsData,
    initialTabID: currentProjectIndex,
  });

  return (
    <SecondaryTabs
      className={classes.projectSelector}
      selectedTab={selectedTokenTab}
      tabs={tokenTabs}
      visible
    />
  );
};
